import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Divider } from "@material-ui/core";
import { InputLabel, TextField } from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useHistory, useParams } from "react-router-dom";

import * as Yup from "yup";
import Select from "../../formUI/Select";
import { useDispatch } from "react-redux";
import axios from "axios";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import {
	openLoader,
	closeLoader,
} from "../../../redux/actions/loader/loaderActions";
import { closeModal } from "../../../redux/actions/modal/modalActions";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { makeStyles } from "@material-ui/core";
import { toTitleCase } from "../../../util/titleCase";

const useStyles = makeStyles({
	root: {
		"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"& .MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-input.MuiOutlinedInput-input":
			{
				textAlign: "center",
				padding: "8.1px 14px",
			},
	},
	select: {
		"& .MuiOutlinedInput-root": {
			color: "#414141",
			fontFamily: "Avenir",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "16px",
		},
		"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			outline: "none",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
			backgroundColor: "#ffffff",
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: "#E0E0E0",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #E0E0E0",
		},
	},
});

const AddPaymentRoute = ({
	content,
	identifier,
	id,
	fetchPaymentRoute,
}: {
	content?: any;
	identifier: string;
	id: any;
	fetchPaymentRoute: any;
}) => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const validate = Yup.object({
		routeid: Yup.number().required("Required"),
		providerid: Yup.number().required("Required"),
		otp: Yup.number().required("Required"),
	});

	const [providers, setProviders] = useState<any>();
	const [routes, setRoutes] = useState<any>();
	const [details, setDetails] = useState<any>();

	const fetchProviders = async () => {
		dispatch(openLoader());
		try {
			const data: any = await axios.get(`/v1/utility/providers`);
			setProviders(data?.data);
			dispatch(closeLoader());
		} catch (err: any) {
			dispatch(closeLoader());
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent:
							err.response?.data?.message ||
							err?.data?.message ||
							err?.message ||
							err,
						toastType: "error",
					})
				)
			);
		}
	};

	const fetchRoutes = async () => {
		dispatch(openLoader());
		try {
			const data: any = await axios.get(`/v1/utility/routes`);
			setRoutes(data?.data);
			dispatch(closeLoader());
		} catch (err: any) {
			dispatch(closeLoader());
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent:
							err.response?.data?.message ||
							err?.data?.message ||
							err?.message ||
							err,
						toastType: "error",
					})
				)
			);
		}
	};

	useEffect(() => {
		fetchProviders();
		fetchRoutes();
	}, []);

	useEffect(() => {
		axios.get<any>(`/v1/business/${id}`).then((res) => {
			setDetails(res.data);
		});
	}, [id]);

	let providerOptions = providers?.providers?.map(function (provider: any) {
		return {
			name: provider.providerid,
			label: provider.providershortname,
		};
	});

	let routeOptions = routes?.routes?.map(function (route: any) {
		return {
			name: route.id,
			label: `${
				route?.paymentmethod !== null
					? `${toTitleCase(route?.paymentmethod)} |`
					: ""
			} ${
				route?.authoption !== null ? `${toTitleCase(route?.authoption)} |` : ""
			} ${route?.scheme !== null ? `${toTitleCase(route?.scheme)} |` : ""} ${
				route?.region !== null ? `${toTitleCase(route?.region)} |` : ""
			} ${
				route?.currency !== null ? `${toTitleCase(route?.currency)} |` : ""
			}  ${route?.type !== null ? `${toTitleCase(route?.type)}` : ""}`,
		};
	});

	const INITIAL_VALUES = {
		routeid: content ? content.id : "",
		providerid: content ? content.providerid : "",
		otp: "",
	};

	return (
		<div className={styles.generalFourReuse}>
			<h3 className={styles.generalh3}>{identifier} Payment Route</h3>
			<Divider />

			<div className={styles.selectinput}>
				<Formik
					initialValues={INITIAL_VALUES}
					validationSchema={validate}
					onSubmit={async (values) => {
						dispatch(openLoader());
						try {
							const newObject =
								identifier === "Edit"
									? {
											merchantrouteid: content?.id,
											providerid: values.providerid,
											otp: values.otp,
									  }
									: {
											...values,
									  };

							const payload = { ...newObject };

							const response = await axios.post(
								`/v1/business/${id}/payment/route/add`,
								payload
							);

							if ((response?.data as any)?.code === "success") {
								fetchPaymentRoute();
								dispatch(
									openToastAndSetContent({
										toastContent: (response?.data as any)?.message,
										toastType: "success",
									})
								);
								dispatch(closeLoader());
								dispatch(closeModal());
							} else {
								dispatch(
									openToastAndSetContent({
										toastContent: (response?.data as any)?.message,
										toastType: "error",
									})
								);
							}
						} catch (error) {
							if (axios.isAxiosError(error)) {
								dispatch(
									openToastAndSetContent({
										toastContent:
											(error.response?.data as any).message || error.message,
										toastType: "error",
									})
								);
							}
						}

						dispatch(closeLoader());
					}}
				>
					{(props) => (
						<Form>
							<div>
								{identifier === "Add" && (
									<>
										<InputLabel>
											<span className={styles.span}>Route</span>
										</InputLabel>
										<Field
											as={Select}
											helperText={
												<ErrorMessage name="routeid">
													{(msg) => <span style={{ color: "red" }}>{msg}</span>}
												</ErrorMessage>
											}
											name="routeid"
											size="small"
											options={routeOptions}
											className={classes.select}
											style={{
												marginTop: "8px",
												marginBottom: "18px",
											}}
										/>
									</>
								)}

								<InputLabel>
									<span className={styles.span}>Provider</span>
								</InputLabel>
								<Field
									as={Select}
									helperText={
										<ErrorMessage name="providerid">
											{(msg) => <span style={{ color: "red" }}>{msg}</span>}
										</ErrorMessage>
									}
									name="providerid"
									size="small"
									options={providerOptions}
									className={classes.select}
									style={{
										marginTop: "8px",
										marginBottom: "18px",
									}}
								/>

								<InputLabel>
									<span className={styles.header}>OTP</span>
								</InputLabel>

								<Field
									as={TextField}
									helperText={
										<ErrorMessage name="otp">
											{(msg) => <span style={{ color: "red" }}>{msg}</span>}
										</ErrorMessage>
									}
									name="otp"
									placeholder="otp"
									variant="outlined"
									margin="normal"
									type="number"
									size="small"
									fullWidth
								/>
								<button
									style={{
										backgroundColor: "#27AE60",
										fontFamily: "Avenir",
										fontStyle: "normal",
										fontWeight: "bold",
										fontSize: "16px",
										lineHeight: "19px",
										textAlign: "center",
										border: "none",
										outline: "none",
										width: "100%",
										color: "#FFFFFF",
										padding: "13.39px 0",
										marginTop: "30px",
										cursor: "pointer",
										borderRadius: "20px",
									}}
									type="submit"
								>
									Submit
								</button>
							</div>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
};

export default AddPaymentRoute;
